export default __webpack_public_path__ + "static/media/student-profile.cb6bea31.png";